import React, {Fragment, useEffect, useState} from 'react'
import axios from 'axios';
import Cookies from 'universal-cookie';
import WCMImage from './sfc/wcmimage';
import SafeLink from './sfc/safelink'
const cookies = new Cookies();
const cookiePrefix = "ct_aotw_";
let athlete_list = require('../data/athletes.sheet.json')
athlete_list = athlete_list.filter(i => i.Page_Date.length != 0)
let storySettings = require("../data/story_settings.sheet.json");
storySettings = storySettings[0];
var moment = require('moment');
// Get poll date based on pub date
// The leading 1 distinguishes from a sfcde poll, get hour as well

const Voting = ({storyChoice, setStoryChoice, pollPrefix, poll_date, voted, theme_color, setVoted}) => {
    let filtered_list = athlete_list.filter(i => Date.parse(new Date(i.Page_Date)) == poll_date)
    // Add an extra number for the market
    var extra_number = 50;
    switch(storySettings.Market_Key){
        case "SFC": extra_number = 51; break;
        case "Houston": extra_number = 52; break;
        case "SanAntonio": extra_number = 53; break;
        case "Albany": extra_number = 54; break;
        case "CT": extra_number = 55; break;
        case "TK": extra_number = 56; break;
    }
    let pollDate = pollPrefix + poll_date + extra_number;
    const [submitting, setSubmitting] = useState(false)
    // const [storyChoice, setStoryChoice] = useState(null)
    const [email, setEmail] = useState('')
    const [emailValid, setEmailValid] = useState(null)
    const [errorSubmitted, setErrorSubmitted] = useState(false)
    const [votedString, setVotedString] = useState("")
    const [newsletterSignup, setNewsletterSignup] = useState(false)

    useEffect(() => {
    let cookieVal = cookies.get(cookiePrefix+storySettings.Writein_Channel+pollDate);
    console.log(cookieVal)
    if (cookieVal && !voted){ // If it hasn't detected that we've already voted, make it so
      // Break apart cookie so we can get vote and write-in val

      setVoted(true)
      setVotedString(cookieVal.Name)
    }
    })
    const checkSubmitStatus = () =>{
        // Check if email is formatted like an email
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
          // Valid email
          setEmailValid(true);
        } else {
          // Invalid email
          setEmailValid(false);
          return false;
        }

        // Check all values
        if (email){
          // Tests passed! Return true
          return true;
        }
        // If tests were not passed, return false
        return false;
      }
    const handleSubmit = (e) => {
        e.preventDefault()
        // If we are already submitting, just return
        if (submitting){
          return false;
        }
        // See if we're able to submit
        if (checkSubmitStatus()){
          // Change the button graphic to show we're doing something
         setSubmitting(true)
          // Go ahead with the submit
          if (typeof window !== "undefined"){
            window.grecaptcha.ready(() => {
              // This will fail on mobile because reCAPTCHA does not work on dev domains
              window.grecaptcha.execute('6LeBOJAUAAAAAPH7JcaZoQpNcXoHz8T6bFjqlxRg', {action: 'athleteoftheweek'}).then((token) => {
                let tempState = {

                }
                // Getting userAgent in case we need for testing
                if (typeof navigator !== "undefined"){
                  tempState.userAgent = navigator.userAgent;
                }
                tempState.pageChoices = {0: {
                    storyChoice: [storyChoice.Name],
                    writein: "",
                    max_choice: 1,
                    question: "Vote for this week's Athlete of the Week"
                }}
                tempState.newsletterSignup = newsletterSignup;
                tempState.followSignup = false;
                tempState.pollID = pollDate;
                tempState.uniqueID = pollDate;
                tempState.writeinChannel = storySettings.Writein_Channel;
                tempState.customSailID = storySettings.NewsletterID;
                tempState.marketKey = storySettings.Market_Key;
                tempState.logSource = 'athleteoftheweek'
                tempState.email = email


                axios.post("https://projects.sfchronicle.com/feeds/voting/entry_aow.php", {token: token, formData: tempState}, {headers: {'Content-Type': 'application/json'}}).then((response) => {
                  // If successful, show end of form

                  if (response.status === 200){
                    setVoted(true)
                    setVotedString(storyChoice.Name)
                    // Prevent multiple entries (unless we want to allow that)

                      // Set cookie to prevent double-voting
                    var moment = require('moment');
                    cookies.set(cookiePrefix+storySettings.Writein_Channel+pollDate, storyChoice, { path: '/' });
                  }
                });
                return true;
              });
            });
          }
        } else {
          // Submit error! Change state to expose error help text
          setErrorSubmitted(true)
          // Put focus back into field
        }

    }

    const handleEmailEntry = (event) => {
        if (!voted){
          setEmail(event.target.value)
        }
      };
    const handleChange = (e) =>{
        setStoryChoice(filtered_list.find(({Name}) => Name === e.target.value))
      }
    const handleCheck = (e) => {
        setNewsletterSignup(!newsletterSignup)
    }
    return (
      <>
        <div className="aotw-voting-form" id="aotw-vote-module" noValidate autoComplete="off">
        	{/* survey options */}
        {storyChoice && storyChoice.Image && storyChoice.Image.length > 0 && (<div className='voting-form-player-card'>

        <WCMImage wcm={storyChoice.Image} alt={storyChoice.Name} className="aotw-card-image" lz={true}/>
        <div className='player-card-text'>
            <h3>{storyChoice.Name}</h3>
            <h3>{storyChoice.School}</h3>
        </div>
        </div>)}
        <div className={'voting-form-column-right'}>
        <h3>{storySettings.Voting_Header}</h3>
          {voted ? (
            <Fragment>
              {votedString &&
                <p id="voted-report">You voted for <span>{votedString}</span></p>
              }
            </Fragment>
          ) : (
          <div className='voting-dropdown'>
            <label for="athletes">Select an option:</label>
           <select name="athletes" value={storyChoice ? storyChoice.Name : null} onChange={((e) => handleChange(e))}>
           <option value={null} selected>Select an option</option>
            {filtered_list.map((item) => {
              return <option value={item.Name}>{item.Name}</option>
            })}
           </select>
           </div>
          )}



              <Fragment>
                {!voted ? (
                <Fragment>
                  <div className='voting-dropdown'>
                      <label for="voting-email-input">Enter your email:</label>
                      <input name="voting-email-input" className="voting-email-input" type="text" onChange={(e) => {handleEmailEntry(e)}} />


                      </div>
                      <div className="newsletter-signup-wrapper">
                    {storySettings.NewsletterID.length > 0 && <input type="checkbox" className="input-checkbox-voting" name='newsletter-signup-voting' onChange={(e) => {handleCheck(e)}}/>}
                    {storySettings.NewsletterID.length > 0 && <label className="newsletter-signup-help"for='newsletter-signup-voting'>{storySettings.Voting_Newsletter_Signup}</label>}
                    </div>
                    {storySettings.NewsletterID.length > 0 && <p className='newsletter-legal-voting' dangerouslySetInnerHTML={{__html: storySettings.Voting_Newsletter_Legal}} />}
                    {errorSubmitted &&
                    <p className="error" id="error-help">Please enter the required information above.</p>
                     }
                      <button style={{backgroundColor: theme_color}} className="submit" onClick={(e) => {handleSubmit(e)}}>
                        {submitting ? (
                          <span>Submitting</span>
                        ) : (
                          <span>Submit</span>
                        )}
                      </button>
                      </Fragment>
                ) : (
                  <div className="thank-you" dangerouslySetInnerHTML={{__html: storySettings.Thank_You_Text }} />
                )}
              </Fragment>
          </div>
          </div>
          <div className="aotw-disclaimer-text">{storySettings.Voting_Disclaimer} <SafeLink href={storySettings.voting_rules} withinProject={false}>See the full voting rules.</SafeLink>
          </div>
      </>
    )
}

export default Voting;
